
  import { scrollToTop } from '~/scripts/utils';

  export default {
    middleware: ['pages/products/insurance/home-insurance/index', 'meta-tags', 'breadcrumbs', 'pages/car-home-insurance-under-maintenance'],
    data () {
      return {
        basePath: 'compare-home-insurance',
        formDisabled: false
      };
    },
    created () {
      this.$store.dispatch('matomo/trackIndexPageViewed', {name: 'Home Insurance index page viewed'});
      this.$cookies.remove('bonkers-ie-home-insurance-capture-point');
      this.$cookies.remove('bonkers-ie-home-insurance-search');
      this.$store.commit('search/reset', { type: 'homeInsurance' });
    },
    mounted () {
      scrollToTop();
    }
  };
